import authClient from '@/plugins/axios/authClient'

export default {
  /**
   *
   * @param {*} refresh 토큰
   * @returns
   */
  async signinRefresh(refresh) {
    const { data } = await authClient.post('/auth/token/refresh', {
      refresh,
    })
    return {
      data: {
        accessToken: data.access,
        refreshToken: data.refresh,
      },
    }
  },
  /**
   *
   * @param {*} username 아이디
   * @param {*} password 패스워드
   * @returns
   */
  signin(username, password) {
    return authClient.post('/auth/login', {
      email: username,
      password,
    })
  },
}
